import listQuery from 'graphql/queries/dashboard/DashboardListQuery.graphql';
import instanceQuery from 'graphql/queries/dashboard/DashboardQuery.graphql';
import defaultQuery from 'graphql/queries/dashboard/DashboardDefaultQuery.graphql';
import mutationQuery from 'graphql/mutations/dashboard/DashboardsMutation.graphql';
import fragment from 'graphql/fragments/dashboard/DashboardFragment.graphql';
import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const Dashboard = {
  type: 'Dashboard',
  title: 'Dashboard',
  formTitle: 'Profit4 Dashboard',
  formUrl: '/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'DASHBOARD',
  operations: ALLOW_EDIT,
};

export default Dashboard;
